import { clearRegistrationUser } from "utils/fns";
import { api } from "./api";

type SignInRequestData = {
  username: string;
  password: string;
  apiKey?: string;
  grant_type?: string;
};

export function signInRequest(data: SignInRequestData) {
  data["apiKey"] = process.env.REACT_APP_APIKEY;
  data["grant_type"] = "password";

  return api
    .post("/auth/token", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      // console.error(error.response.data.message);
      throw new Error("Dados incorretos ou CPF não cadastrado."); //error.response.data;
    });
}

export function fetchUser() {
  return api
    .get("/player/me/status")
    .then(async (response) => {
      let user = response.data;
      if (user) {
        user = { ...user, detail: await getUserDetail(user._id) };

        console.log("current_user", user);

        return user;
      } else {
        document.dispatchEvent(new CustomEvent("signout"));
      }
    })
    .catch((error) => {
      // console.log(error);
    });
}

export async function getUserAcessor(key: string) {
  try {
    let query = [
      {
        $match: {
          matricula: key,
        },
      },
    ];
    const { data } = await api.post(
      "/database/user_accessor__c/aggregate",
      query
    );

    if (!Array.isArray(data)) {
      return null;
    } else {
      return data[0];
    }
  } catch (e: any) {
    throw e;
  } finally {
  }
}

export async function getUserDetail(key: string) {
  try {
    const acessor = await getUserAcessor(key);

    let query = [
      {
        $match: {
          _id: clearRegistrationUser(key),
        },
      },
    ];
    const { data } = await api.post(
      "/database/player_fields__c/aggregate",
      query
    );

    if (!Array.isArray(data)) {
      return null;
    } else {
      const detail = data[0];
      return {
        ...detail,
        isBoss:
          (detail.cad_missao === 0 &&
            detail.cod_etapa === 5 &&
            [3001, 3002].includes(detail.funcao_localizacao)) ||
          detail.isSpecialist
          //  ||!!acessor
            ? true
            : false,
        isDirector:
          detail.grupo === "CONSELHO DIRETOR/GG UE/AUDITOR GERAL" &&
          detail.active,
        // acessor: acessor,
        prefixo: detail.prefixo,
      };
    }
  } catch (e: any) {
    throw e;
  } finally {
  }
}

export function registerUser(data: any) {
  const payload = {
    _id: `${parseInt(data.username)}`,
    matricula: data.code,
    name: `${data.first_name}`,
    email: data.email,
    password: data.password,
    extra: {
      mobile: data.phone,
      first_name: data.first_name,
      last_name: data.last_name || "",
    },
  };

  return api
    .put("/database/player_register__c", payload)
    .then((response) => {
      const user = response.data;
      return user;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
}

export async function validateUser(payload: any) {
  try {
    const response = await api.put("/database/player_validate__c", payload);
    if (response.data.status === "Unauthorized") {
      throw new Error(response.data.message);
    } else {
      return response.data;
    }
  } catch (error) {
    throw error;
  }
}

export async function recoverPassword(id: string) {
  try {
    const response = await api.get(
      `/player/password/change?player=${id.toLocaleLowerCase().trim()}`
    );
    if (response.data.status === "Unauthorized") {
      throw new Error(response.data.message);
    } else {
      return response.data;
    }
  } catch (error: any) {
    throw error;
  }
}

export async function updatePassword(payload: any) {
  try {
    const { username, password, code } = payload;
    const response = await api.put(
      `/player/password?player=${username
        .toLocaleLowerCase()
        .trim()}&new_password=${password}&code=${code}`
    );
    if (response.data.type === "OK") {
      return true;
    } else {
      throw new Error("It was not possible to update your password");
    }
  } catch (error: any) {
    throw new Error("It was not possible to update your password");
  }
}
